const PROMO_PREFIX = '@@promo/';

export const PROMO_ACTION_TYPES = {
    APPLY_REQUEST: `${PROMO_PREFIX}APPLY_REQUEST`,
    APPLY_SUCCESS: `${PROMO_PREFIX}APPLY_SUCCESS`,
    APPLY_FAILURE: `${PROMO_PREFIX}APPLY_FAILURE`,
    CLEAR_PROMO: `${PROMO_PREFIX}CLEAR_PROMO`,
};